import {
  SHOW_LOGS,
  DEFAULT_LOG_TEMPLATE
} from './constants';

export function showLog() {
  SHOW_LOGS && console.log(DEFAULT_LOG_TEMPLATE, ...arguments);
}

export function showWarn() {
  SHOW_LOGS && console.warn(DEFAULT_LOG_TEMPLATE, ...arguments);
}

export function showError() {
  SHOW_LOGS && console.error(DEFAULT_LOG_TEMPLATE, ...arguments);
}



// WEBPACK FOOTER //
// ./src/logger.js